import { gql } from '@src/lib/gql'

/** Fields for a target-user match that represents an open advisor board seat. */
const OPEN_SEAT_MATCH_SELECTION = `
  id
  userMatchId
  targetUserId
  searchingUserId
  matchScore
  matchScoreAsPercent
  matchFactors
  matchExplanation
  searchingUser {
    id
    userId
    fullName
    displayName
    firstName
    pictureUrl
    slug
    shortBio
    title
  }
  userSearch {
    id
    userSearchId
    title
    naturalLanguagePrompt
    compensationTypeKeys
    commitmentTypeKeys
    industryKeys
    requiredSkills
    groupRequest {
      id
      groupRequestId
      groupRequestTypeKey
      publishStatusKey
      title
      needExplanation
      compensationTypeKeys
      timeCommitmentTypeKeys
      skillTagTitles
      currentUserGroupCommitment {
        id
        groupCommitmentId
        createdAt
        acceptedAt
        rejectedAt
      }
      requestingUser {
        id
        userId
        fullName
        displayName
        firstName
        pictureUrl
        slug
        shortBio
        title
      }
      requestingCompany {
        id
        companyId
        name
        elevatorPitch
        stageKey
        industryKeys
      }
      compensationTypes {
        id
        key
        title
      }
      timeCommitmentTypes {
        id
        key
        title
      }
    }
  }
`

/**
 * Reverse marketplace feed: matches where the current user is the *target advisor*.
 * Server INNER JOINs UserSearch → advisor GroupRequest so founders always resolve
 * (does not rely on FE filtering a generic member-match list).
 */
export const ADVISOR_MATCHED_OPEN_SEATS = gql`
  query AdvisorMatchedOpenSeats($pageSize: Int, $page: Int) {
    advisorMatchedOpenSeats(
      pageSize: $pageSize
      page: $page
      order: [["matchScore", "desc"]]
    ) {
      items {
        ${OPEN_SEAT_MATCH_SELECTION}
      }
      pagination {
        itemCount
        hasNextPage
        page
        pageSize
        pageCount
      }
    }
  }
`

export const ADVISOR_OPEN_SEAT_MATCH = gql`
  query AdvisorOpenSeatMatch($userMatchId: String!) {
    scoUserMatch(userMatchId: $userMatchId) {
      ${OPEN_SEAT_MATCH_SELECTION}
    }
  }
`
